var _defs, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFlagEn = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 24,
    height: 17.143,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e",
    width: 22.857,
    height: 16,
    x: 0.571,
    y: 0.571,
    rx: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5 -1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#22438B",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.429 1.143l-2.316.03.03 2.256 19.408 12.603 2.328-.042-.043-2.244z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7152A",
    d: "M2.286 1.143L1.143 2.286 21.714 16l1.143-1.143z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.571 1.143h2.286v2.286S9.43 11.88 3.45 16.032c-.072.05-2.283.004-2.283.004L.988 13.86 20.571 1.143z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7152A",
    d: "M21.763 1.111l1.094 1.175L2.286 16l-1.143-1.143z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.143 1.143h5.714v4.571h8v5.715h-8V16H9.143v-4.571h-8V5.714h8z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7152A",
    d: "M10.286 1.143h3.428v5.714h9.143v3.429h-9.143V16h-3.428v-5.714H1.143V6.857h9.143z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#2F343A",
    strokeOpacity: 0.157,
    xlinkHref: "#e"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlagEn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flag-en.a93f43b6.svg";
export { ForwardRef as ReactComponent };